"use strict"
var $ = avm.require('cash');
if (typeof $_ !== 'undefined') {
    $ = $_;
}

$(document).ready(function () {
    var id = window.location.hash;
    $("#partners-about").show();
    $("#partners-solutions").hide();
    $("#partners-benefits").hide();
    $("#partners-knowledge").hide();
    $("#top .top-hero-0").first().show();
    switch(id){
        case '#about':
            $("#top .top-hero-0").first().show();
            $("#top .top-hero-1").first().hide();
            $("#top .top-hero-2").first().hide();
            $("#top .top-hero-3").first().hide();
            $("#partners-about").show();
            $("#partners-solutions").hide();
            $("#partners-benefits").hide();
            $("#partners-knowledge").hide();
            $("#nav-wrap-tab1").addClass("active");
            break;
        case '#solutions':
            $("#top .top-hero-1").first().show();
            $("#top .top-hero-0").first().hide();
            $("#top .top-hero-2").first().hide();
            $("#top .top-hero-3").first().hide();
            $("#partners-about").hide();
            $("#partners-solutions").show();
            $("#partners-benefits").hide();
            $("#partners-knowledge").hide();
            $("#nav-wrap-tab2").addClass("active");
            break;
        case '#benefits':
            $("#top .top-hero-2").first().show();
            $("#top .top-hero-0").first().hide();
            $("#top .top-hero-1").first().hide();
            $("#top .top-hero-3").first().hide();
            $("#partners-about").hide();
            $("#partners-solutions").hide();
            $("#partners-benefits").show();
            $("#partners-knowledge").hide();
            $("#nav-wrap-tab3").addClass("active");
            break;
        case '#knowledge':
            $("#top .top-hero-3").first().show();
            $("#top .top-hero-0").first().hide();
            $("#top .top-hero-2").first().hide();
            $("#top .top-hero-1").first().hide();
            $("#partners-about").hide();
            $("#partners-solutions").hide();
            $("#partners-benefits").hide();
            $("#partners-knowledge").show();
            $("#nav-wrap-tab4").addClass("active");
            break;
            default:
                window.location.hash = '#about';
                $("#nav-wrap-tab1").addClass("active");
                break;
    }

    //Making modal buttons keyboard focusable
    $('.btn-modal-contactForm').each(function (i, val) {
        $(this).attr('tabindex', 0);
    });

    $('.js-modal-whitepapersForm').each(function (i, val) {
        $(this).attr('tabindex', 0);
    });

    $('.close').each(function (i, val) {
        $(this).attr('tabindex', 0);
    });
    
});

$("#nav-wrap-tab1").on('click',function () {
    $("#top .top-hero-0").first().show();
    $("#top .top-hero-1").first().hide();
    $("#top .top-hero-2").first().hide();
    $("#top .top-hero-3").first().hide();
    $("#partners-about").show();
    $("#partners-solutions").hide();
    $("#partners-benefits").hide();
    $("#partners-knowledge").hide();
    $("#nav-wrap-tab1").addClass("active");
    $("#nav-wrap-tab2").removeClass("active");
    $("#nav-wrap-tab3").removeClass("active");
    $("#nav-wrap-tab4").removeClass("active");
});
$("#nav-wrap-tab2").on('click', function () {
    $("#top .top-hero-1").first().show();
    $("#top .top-hero-0").first().hide();
    $("#top .top-hero-2").first().hide();
    $("#top .top-hero-3").first().hide();
    $("#partners-about").hide();
    $("#partners-solutions").show();
    $("#partners-benefits").hide();
    $("#partners-knowledge").hide();
    $("#nav-wrap-tab2").addClass("active");
    $("#nav-wrap-tab1").removeClass("active");
    $("#nav-wrap-tab3").removeClass("active");
    $("#nav-wrap-tab4").removeClass("active");
});
$("#nav-wrap-tab3").on('click',function () {
    $("#top .top-hero-2").first().show();
    $("#top .top-hero-0").first().hide();
    $("#top .top-hero-1").first().hide();
    $("#top .top-hero-3").first().hide();
    $("#partners-about").hide();
    $("#partners-solutions").hide();
    $("#partners-benefits").show();
    $("#partners-knowledge").hide();
    $("#nav-wrap-tab3").addClass("active");
    $("#nav-wrap-tab2").removeClass("active");
    $("#nav-wrap-tab1").removeClass("active");
    $("#nav-wrap-tab4").removeClass("active");
});
$("#nav-wrap-tab4").on('click',function () {
    $("#top .top-hero-3").first().show();
    $("#top .top-hero-0").first().hide();
    $("#top .top-hero-2").first().hide();
    $("#top .top-hero-1").first().hide();
    $("#partners-about").hide();
    $("#partners-solutions").hide();
    $("#partners-benefits").hide();
    $("#partners-knowledge").show();
    $("#nav-wrap-tab4").addClass("active");
    $("#nav-wrap-tab2").removeClass("active");
    $("#nav-wrap-tab3").removeClass("active");
    $("#nav-wrap-tab1").removeClass("active");
});

//About CTA to Solutions
$('.solutions-btn').first().on("click", function () {
    $("#partners-about").hide();
    $("#partners-solutions").show();
    $("#partners-benefits").hide();
    $("#partners-knowledge").hide();
    $("#nav-wrap-tab2").addClass("active");
    $("#nav-wrap-tab1").removeClass("active");
    $("#nav-wrap-tab3").removeClass("active");
    $("#nav-wrap-tab4").removeClass("active");
    $("#top .top-hero-1").first().show();
    $("#top .top-hero-0").first().hide();
    $("#top .top-hero-2").first().hide();
    $("#top .top-hero-3").first().hide();
    window.scrollTo(0, 0);
});

//Sticky scrolling
var waypoints = avm.require('avast.web.waypoints'),
    $window = $(window),

    $secondaryNav = $('#sticky-subnav'), //row containing the nav tab snippet
    $navLinks = $('#sticky-subnav .nav-link'), // all nav links

    // anchors IDs. Add as many as there is item in your nav
    $anchor1 = $('#solutions-smart-life'),
    $anchor2 = $('#solutions-family-protection'),
    $anchor3 = $('#solutions-vpn'),
    $anchor4 = $('#solutions-mobile-security'),

    // if you want sticky navtabs, this is a waypoint where it stops to be sticky
    $stickyEndWaypoint = $('#sticky-navtabs-end'),

    // for handling the top sticky bar. Fixes overlapping issues.
    //$stickyBar = $('.sticky-bar'),

    // Activating such tab which is currently displayed
    setActive = function ($this) {
        $navLinks.removeClass('active');
        $this.addClass('active');
    },
    navItemsActivation = function () {
        // Tab IDs are made of container ID (nav-wrap is default value) and '-tab'+ tab number. You can set custom ID in snippet parameter.
        // Value 99 should correspond to margin-top value in styles (see :before element of anchored section)
        if (waypoints($anchor1, ($window.height() - 100), null, true)) { setActive($('#nav-wrap-subtab1')); }
        if (waypoints($anchor2, ($window.height() - 100), null, true)) { setActive($('#nav-wrap-subtab2')); }
        if (waypoints($anchor3, ($window.height() - 100), null, true)) { setActive($('#nav-wrap-subtab3')); }
        if (waypoints($anchor4, ($window.height() - 100), null, true)) { setActive($('#nav-wrap-subtab4')); }
    };

$('#nav-wrap-subtab1').on('click', function(){
    setActive($('#nav-wrap-subtab1'));
    window.setTimeout(function () {
        window.scrollBy(0, 10);
    }, 700);
});
$('#nav-wrap-subtab2').on('click', function () {
    setActive($('#nav-wrap-subtab2'));
    window.setTimeout(function () {
        window.scrollBy(0, 10);
    }, 700);
});
$('#nav-wrap-subtab3').on('click', function () {
    setActive($('#nav-wrap-subtab3'));
    window.setTimeout(function () {
        window.scrollBy(0, 10);
    }, 700);
});
$('#nav-wrap-subtab4').on('click', function () {
    setActive($('#nav-wrap-subtab4'));
    window.setTimeout(function () {
        window.scrollBy(0, 10);
    }, 700);
});

$window.on('resize scroll', navItemsActivation);

$window.on('resize scroll', function () {
    if (waypoints($anchor1, null, null, true)) {
        $secondaryNav.addClass('is-sticky');
    } else {
        $secondaryNav.removeClass('is-sticky');
        $navLinks.removeClass('active');
    }

    if (waypoints($stickyEndWaypoint, null, null, true)) {
        $secondaryNav.addClass('hidden');
    } else {
        $secondaryNav.removeClass('hidden');
    }
});


//Knowledge buttons on hover
var imgs = document.querySelectorAll('#partners-knowledge .btn img');
for(var i=0; i<imgs.length; i++){
    imgs[i].addEventListener('mouseover', function() {
        this.src = "https://static3.avast.com/1/web/i/v2/components/download-purple.svg";
    });
    imgs[i].addEventListener('mouseout', function () {
        this.src = "https://static3.avast.com/1/web/i/v2/components/download-white.svg";
    });
}

//Form management
var $btnContactFrom = $('.btn-modal-contactForm'),
    $modal_textForReplace = $('.js-modal-btn-text', 0),
    $modal_whitepapersButtons = $('.js-modal-whitepapersForm');

// Open contact form modal
$btnContactFrom.on('click', function () {
    $modal_whitepapersButtons.removeClass('activeLink');
    $('#carriers-contact-form').load('carriers-contact-form', function () {
        initAvastForm();
        $('#carriers-contact-form').siblings().show();
        $('#carriers-contact-form').find('input.button[type="submit"]').removeClass('button blue large').addClass('btn btn-primary btn-lg')
    })
})

// Open whitepapers form modals
$modal_whitepapersButtons.on('click', function (e) {
    $modal_whitepapersButtons.removeClass('activeLink');
    $(this).addClass('activeLink');
    $('#carriers-whitepapers-form').load('carriers-contact-form', function () {
        initAvastForm();
        $('#carriers-whitepapers-form').siblings().show();
        $('#carriers-whitepapers-form').find('input.button[type="submit"]').attr('value', $modal_textForReplace.text()).removeClass('button blue large').addClass('btn btn-primary btn-lg');
    })
})

// Contact form after success
$(document).on('avastform-linear-success', function () {
    initAvastForm();
    if ($($modal_whitepapersButtons).hasClass('activeLink')) {
        window.open($('.js-modal-whitepapersForm.activeLink').attr('href'), '_blank');
        $modal_whitepapersButtons.removeClass('activeLink');
    }
    $('#carriers-whitepapers-form').siblings().hide();
    $('#carriers-contact-form').siblings().hide();
});

function finishForm(){
    initAvastForm();
    if ($($modal_whitepapersButtons).hasClass('activeLink')) {
        window.open($('.js-modal-whitepapersForm.activeLink').attr('href'), '_blank');
        $modal_whitepapersButtons.removeClass('activeLink');
    }
    $('#carriers-whitepapers-form').siblings().hide();
    $('#carriers-contact-form').siblings().hide();
}

//Video stop functionality
/*$('.js-modal-close','#modalVideoYoutube').on('click', function(){
    var video_src = $('.modal-body', '#modalVideoYoutube').children('iframe').attr('data-src');
    $('.modal-body', '#modalVideoYoutube').children('iframe').attr('src', '');
    $('.modal-body', '#modalVideoYoutube').children('iframe').attr('src', video_src);

    $('.modal-body', '#modalVideoYoutube').children('iframe').attr('data-src', '');
    $('.modal-body', '#modalVideoYoutube').children('iframe').attr('data-src', video_src);

});*/

